import React, { useEffect, useRef, useState, useCallback } from "react";
import ParentModal from "../parentModal";
import { all_routes } from "../../../router/all_routes";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { parentData } from "../../../../core/data/json/parentlistdata";
import { TableData } from "../../../../core/data/interface";
import Table from "../../../../core/common/dataTable/index";
import TooltipOption from "../../../../core/common/tooltipOption";
import { _get, _post } from "../../../Utils/Helper";
import { toast } from "react-toastify";
import { Button, Col, Row, Select } from "antd";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import { SingleValue } from "react-select";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/reducers";

const ParentList = () => {
  const _form = {
    query_type: "create",
    id: "",
    name: "",
    class_name: "",
    status: "",
    date_of_birth: "",
    parent_id: "",
    image: "",
    subject: "",
    compose_sms: "",
  };

  const [form, setForm] = useState(_form);
  const [allChildren, setAllChildren] = useState<any[]>([]);
  const [selectedChildren, setSelectedChildren] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [childlist, setChildlist] = useState<any[]>([]);
  const [show, setShow] = useState(false);
  const [parentDetails, setParentDetails] = useState<any>({});
  const [selectedParentId, setSelectedParentId] = useState<number | null>(null);
  // const [refreshKey, setRefreshKey] = useState(0);
  const routes = all_routes;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const data = parentData;
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const handleChange = (e: any) => {
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  };
  const handleAddChild = (parentId: string) => {
    setLoading(true);
    _post(
      "students",
      {
        parent_id: selectedParentId,
        admission_no: selectedChildren,
        query_type: "add-parent",
      },
      (res) => {
        if (res.success) {
          setLoading(false);
          toast.success("Children updated successfully");
          setSelectedChildren([]);
          getThisParentChildren()
          getParents();
        }
      },
      (err) => {
        setLoading(false);
        toast.error(err.message)
      }
    );
  };

  const handleClose = () => {
    setShow(false);
  };
  const handleEditClick = (parentId: number) => {
    setSelectedParentId(parentId);
    console.log(parentId);
  };
  const [new_data, setNewData] = useState([]);

  const getParents = () => {
    _get(
      `get-parent?query_type=select-all`,
      (res) => {
        if (res.success && res.results.length > 0) {
          setNewData(res.results);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };


  useEffect(() => {
    if(form.class_name){
      _get(
        `students?query_type=select-class&current_class=${form.class_name}`,
        (res) => {
          setAllChildren(res.data);
          console.log(res.data[0]);
        },
        (err) => toast.error(err.message)
      );
    }
  }, [form.class_name]);

  

   useEffect(() => {
      if (selectedParentId) {
        _get(
          `get-parent?query_type=select&id=${selectedParentId}`,
          (res) => {
            if (res.success && res.results.length > 0) {
              setParentDetails(res.results[0]);
            }
          },
          (err) => console.error(err.message)
        );
      }
    }, [selectedParentId]);
  const getThisParentChildren = useCallback(()=>{
    if(selectedParentId){
    _get(
      `get-parent?query_type=childlist&id=${selectedParentId}`,
      (res) => {
        setChildlist(res.results);
        console.log(res.results);
      },
      (err) => console.error(err.message)
    );
  }
},[selectedParentId])

useEffect(()=>{
   getThisParentChildren()
},[getThisParentChildren])

  const handleSubmit = (e: any) => {
    e.preventDefault();
    _post(
      "compose_sms?query_type=create",
      form,
      (res) => {
        // setLoading(false);
        setForm(_form);
        toast.success("Created Compose SMS successfully");
      },
      (err) => {
        // setLoading(false);
        console.error("Error creating Compose:", err);
      }
    );
  };

  useEffect(() => {
    getParents();
  }, []);
  
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      render: (text: string) => (
        <Link to="#" onClick={() => setShow(true)} className="link-primary">
          {text}
        </Link>
      ),
      sorter: (a: TableData, b: TableData) => a.id.length - b.id.length,
    },
    {
      title: "Parent Name",
      dataIndex: "fullname",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link to="#" onClick={() => setShow(true)}>
                {text}
              </Link>
            </p>
            <span className="fs-12">{record.Addedon}</span>
          </div>
        </div>
      ),
    },
    {
      title: "Phone",
      dataIndex: "phone_no",
    },
    {
      title: "Email",
      dataIndex: "email_address",
    },
    {
      title: "Relationship",
      dataIndex: "relationship",
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text: string, record: any, index:number) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    onClick={() => {
                      setShow(true);
                      handleEditClick(record?.id);
                    }}
                  >
                    <i className="ti ti-menu me-2" />
                    View Parent
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_parent"
                    onClick={() => handleEditClick(record.id)}
                  >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                  </Link>
                </li>
                {/* <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#add-child-modal"
                  >
                    <i className="ti ti-plus me-2" />
                    Add Child
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];

  const { user, classes } = useSelector((state: RootState) => state.auth)
  const classOptions = classes?.length ? classes?.map((i: any) => ({
    label: i.class_name,
    value: i.class_name,
  })) : [];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          {/* {JSON.stringify(selectedParentId)} */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              {/* <h3 className="page-title mb-1">Parents</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">People</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Parents
                  </li>
                </ol>
              </nav> */}
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              <div className="mb-2 mr-3">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#add_parent"
                  className="btn btn-primary"
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Parent
                </Link>
              </div>{" "}
              <div className="mb-2">
                <Link
                  to="#"
                  className="btn btn-light d-flex align-items-center"
                  data-bs-toggle="modal"
                  data-bs-target="#add_subject"
                >
                  <i className="ti ti-square-rounded-plus-filled me-2" />
                  Compose SMS
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Parent List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Parents List</h4>

            </div>
            <div className="card-body p-0 py-3">
              {/* Student List */}
              {/* {JSON.stringify(new_data)} */}
              <Table columns={columns} dataSource={new_data} Selection={false} />

              {/* /Student List */}
              <div className="modal fade" id="add_subject">
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title">Compose SMS</h4>
                      <button
                        type="button"
                        className="btn-close custom-btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        <i className="ti ti-x" />
                      </button>
                    </div>
                    <form>
                      <div className="modal-body">
                        <div className="row">
                          <div className="col-md-12">
                            {/* {JSON.stringify(new_class_name)} */}
                            <div className="mb-3">
                              <label className="form-label">SMS</label>
                              <textarea
                                className="form-control"
                                placeholder="Write SMS"
                                rows={4}
                                defaultValue={""}
                                name="compose_sms"
                                value={form.compose_sms}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <Link
                          to="#"
                          className="btn btn-light me-2"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </Link>
                        <Link
                          to="#"
                          data-bs-dismiss="modal"
                          className="btn btn-primary"
                          onClick={handleSubmit}
                        >
                          Send
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /Students List */}
        </div>
      </div>
      {/* /Page Wrapper */}
      <ParentModal
        parentId={selectedParentId}
        onSuccess={() => getParents()}
        onClose={() => setSelectedParentId(null)}
      />
      <Modal show={show} onHide={handleClose} centered size="lg">
        <div className="modal-header">
          <h4 className="modal-title">View Details</h4>
          <button
            type="button"
            className="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body mb-0">
          <div className="parent-wrap">
            <div className="row d-flex align-items-center">
              <div className="col-lg-4">
                <div className="mb-3">
                  <div className="parent-name">
                    <p>Name</p>
                    <h5 className="mb-1">{parentDetails?.fullname}</h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="mb-3 me-5">
                  <div className="parent-name">
                    <p>Email</p>
                    <h5 className="mb-1">{parentDetails?.email_address}</h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="mb-3">
                  <div className="parent-name">
                    <p>Phone</p>
                    <h5 className="mb-1">{parentDetails?.phone_no}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-3">
            <Row>
              <Col md={10} className="mb-3">
                <label className="form-label">Child Class</label>
                <CommonSelect
                  className="select"
                  options={classOptions}
                  handleChange={(newValue: SingleValue<Option>) =>
                    setForm((prev) => ({
                      ...prev,
                      class_name: newValue ? newValue.value : "",
                    }))
                  }
                  defaultValue={{
                    label: form.class_name,
                    value: form.class_name,
                  }}
                />
              </Col>
              <Col md={10} className="mb-3">

                <label className="form-label">Children</label>
                <Select
                  // mode="multiple"
                  style={{
                    width: "80%",
                    zIndex: 1055,
                    marginRight: '10px'
                  }}
                  dropdownStyle={{
                    zIndex: 9999,
                    position: 'fixed'
                  }}
                  onChange={(value) => setSelectedChildren(value)}
                  value={selectedChildren}
                  options={allChildren?.map((child) => ({
                    value: child.admission_no,
                    label:
                      child.student_name + " (" + child.admission_no + ") " + "(" + child.current_class + ") ",
                  }))}
                  getPopupContainer={(triggerNode) => triggerNode.closest('.modal-body') || triggerNode.parentNode as HTMLElement}
                />
              </Col>
              <Col className="pt-4" md={4}>
                <Button
                  type="primary"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                  onClick={() => handleAddChild(parentDetails?.id)}
                  disabled={loading}
                >
                  {loading ? "Adding..." : "Add Child"}
                </Button>
              </Col>
            </Row>
          </div>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5 className="mb-3">Children Details</h5>


            {/* {JSON.stringify(childlist)} */}

          </div> {childlist?.length === 0 && (
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <p>No children found.</p>
            </div>
          )}
          {childlist?.map((child: any, index: number) => (
            <div key={index} className="border rounded p-4 pb-1 mb-3">
              <div className="d-flex align-items-center justify-content-between flex-wrap pb-1 mb-3 border-bottom">
                <span className="link-primary mb-2">{child?.admission_no}</span>
                <span className="badge badge-soft-success badge-md mb-2">
                  <i className="ti ti-circle-filled me-2" />
                  Active
                </span>
              </div>
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div className="d-flex align-items-center mb-3">
                  <div className="ms-2">
                    <p className="mb-0">
                      {/* <Link to={routes.studentDetail}> */}
                      {child?.student_name}
                      {/* </Link> */}
                    </p>
                    <span>{child?.section}</span>
                  </div>
                </div>
                <ul className="d-flex align-items-center flex-wrap">
                  <li className="mb-3 me-4">
                    <p className="mb-1">Class Name</p>
                    <h6 className="fw-normal">{child?.current_class}</h6>
                  </li>
                  <li className="mb-3 me-4">
                    <p className="mb-1">Gender</p>
                    <h6 className="fw-normal">{child?.sex}</h6>
                  </li>
                  <li className="mb-3">
                    <p className="mb-1">Academic Year</p>
                    <h6 className="fw-normal">{child?.academic_year}</h6>
                  </li>
                </ul>
                <div className="d-flex align-items-center">
                  {/* <Link to="#" className="btn btn-light mb-3 me-3">
                  Add Fees
                </Link> */}
                  <Link
                    to="#"
                    // to={`${routes.studentDetail}?admission_no=${child?.admission_no}`}
                    className="btn btn-primary mb-3"
                  >
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
};

export default ParentList;
